import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import { Form, Input, Button, Tooltip, Checkbox, message } from "antd";
import API, { REGISTER } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";

const CreateAccount = () => {
  const [form] = Form.useForm();
  const [, forceUpdate] = useState({});
  const navigate = useNavigate();
  const indexTabLocal = localStorage.getItem("indexLocalCreate") || 2;
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    forceUpdate({});
  }, []);

  const extractApiErrorMessage = (error) => {
    const data = error?.response?.data;
    const nested = data?.data;
    let msg = data?.message ?? nested?.message;
    if (Array.isArray(msg)) {
      msg = msg.filter(Boolean).join(", ");
    }
    if (typeof msg === "string" && msg.trim()) return msg.trim();
    if (typeof data?.error === "string" && data.error.trim()) return data.error.trim();
    if (typeof nested === "string" && nested.trim()) return nested.trim();
    if (typeof error?.message === "string" && error.message.trim()) return error.message.trim();
    return "Có lỗi xảy ra";
  };

  const onCreate = async () => {
    const params = {
      username: form.getFieldValue("username"),
      password: form.getFieldValue("password"),
      isFullAdmin: form.getFieldValue("isSuperAdmin") || false,
    };

    try {
      const response = await API.post(REGISTER, params);
      if (!response?.data) return;

      const result = response.data;
      if (result?.code === "ER_DUP_ENTRY") {
        showError(
          result?.message || "Tên đăng nhập đã tồn tại"
        );
        return;
      }

      localStorage.setItem("indexTabAcc", indexTabLocal);
      navigate("/account");
    } catch (error) {
      showError(extractApiErrorMessage(error));
    }
  };

  const showError = (errorMessage) => {
    messageApi.open({
      type: 'error',
      content: errorMessage,
    });
  };

  const backScreen = () => {
    localStorage.setItem("indexTabAcc", indexTabLocal);
    navigate("/account");
  };

  const renderFormByAdmin = () => {
    return (
      <Form
        className="form-create"
        form={form}
        layout="inline"
        autoComplete="off"
        onFinish={onCreate}
      >
        <div className="col-8">
          <div
            className="col-12"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div className="col-3">
              {TEXT_DEF.text0002} <span style={{ color: "red" }}>*</span>
            </div>
            <div className="col-9">
              <Form.Item
                name="username"
                rules={[
                  {
                    required: true,
                    message: TEXT_DEF.text0004,
                  },
                ]}
                style={{ marginRight: 0 }}
              >
                <Input maxLength={255} />
              </Form.Item>
            </div>
          </div>

          <div style={{ marginBottom: 15 }} />

          <div
            className="col-12"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div className="col-3">
              {TEXT_DEF.text0003} <span style={{ color: "red" }}>*</span>
            </div>
            <div className="col-9">
              <Tooltip title="Mật khẩu có độ dài từ 8-32 ký tự. Bắt buộc có ký tự hoa, ký tự thường, số, ký tự đặc biệt (!@#$%&*)">
                <Form.Item
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: TEXT_DEF.text0004,
                    },
                    {
                      validator: (_, value) => {
                        if (
                          /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*]).{8,32})/.test(
                            value
                          )
                        ) {
                          return Promise.resolve();
                        } else {
                          return Promise.reject("Some message here");
                        }
                      },
                      message: TEXT_DEF.text0003 + " " + TEXT_DEF.text0005,
                    },
                  ]}
                  className="col-12"
                >
                  <Input.Password min={8} maxLength={32} />
                </Form.Item>
              </Tooltip>
            </div>
          </div>

          <div style={{ marginBottom: 15 }} />

          <div
            className="col-12"
            style={{ display: "flex", alignItems: "center" }}
          >
            <div className="col-3">
            </div>
            <div className="col-9">
              <Form.Item name="isSuperAdmin" valuePropName="checked">
                <Checkbox>Super Admin</Checkbox>
              </Form.Item>
            </div>
          </div>

          <div style={{ marginBottom: 30 }} />

          <Form.Item shouldUpdate style={{ width: "100%" }}>
            {() => (
              <div className="lg-btn">
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={
                    !!form
                      .getFieldsError()
                      .filter(({ errors }) => errors.length).length
                  }
                >
                  {TEXT_DEF.text0026}
                </Button>
              </div>
            )}
          </Form.Item>
        </div>
      </Form>
    );
  };

  return (
    <div className="col-12">
      {contextHolder}
      <Button
        type="default"
        htmlType="button"
        style={{ marginBottom: 30 }}
        onClick={backScreen}
      >
        {TEXT_DEF.text0034}
      </Button>
      {renderFormByAdmin()}
    </div>
  );
};

export default CreateAccount;
